import React from 'react';
import StatusWidget from '../../DataTables/DataTableComponents/StatusWidget';

export default function PropertyBankAccountsCard(props) {
	return (
		<div className="PropertyBankAccountsCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid lg:grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">
						Bank Accounts
					</h2>
				</div>
				<div className="col-span-12 lg:col-span-10">
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md">
						<span className="float-right hover:underline">Edit</span>
						<div className="grid md:grid-cols-12">
							<div className="md:col-span-6">
								<div className="font-semibold">Name</div>
								<div>
									<span className="my-1 mr-3">Matt's Checking</span>
									<StatusWidget status="Active" />
								</div>
								<div className="font-semibold mt-4">Type</div>
								<span className="my-1 mr-3">Checking</span>
								<div className="font-semibold mt-4">Account Number</div>
								<span className="mr-2 block">XXXXXX1780</span>
								<div className="font-semibold mt-4">Routing Number</div>
								<span className="mr-2 block">302075830</span>
							</div>
							<div className="md:col-span-6 mt-4 md:mt-0">
								<div className="font-semibold">Account Holder First Name</div>
								<span className="mr-2 block">Matthew</span>
								<div className="font-semibold mt-4">
									Account Holder Last Name
								</div>
								<span className="mr-2 block">Hoelzel</span>
								<div className="font-semibold mt-4">Used For</div>
								<span className="mr-2 block">Subscription, Tax returns</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
